import React from "react";
import { connect } from "react-redux";
import { primary } from "../../../../assets/colorPallet";

function YearBar({ currentCompanyBizminerRatios }) {
  return (
    <div className="flex items-center font-semibold text-center text-white mt-10 mb-10">
      <div
        style={{ backgroundColor: primary }}
        className="absolute left-0 w-full h-12 z-10"
      />
      <div className="z-20" style={{ minWidth: "22em" }} />
      {currentCompanyBizminerRatios?.yearsFormatted?.map((date) => (
        <div className="z-20" style={{ minWidth: "10em" }}>
          {date}
        </div>
      ))}
    </div>
  );
}

const mapStateToProps = (state) => ({
  currentCompanyBizminerRatios: state.financialRatios.currentCompanyBizminerRatios
});

export default connect(mapStateToProps)(YearBar);
